import { render, staticRenderFns } from "./QuestionLanguage.vue?vue&type=template&id=dbd1ad62&scoped=true&"
import script from "./QuestionLanguage.vue?vue&type=script&lang=js&"
export * from "./QuestionLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd1ad62",
  null
  
)

export default component.exports